export function getSafeTicketDescription(
  ticket: { description?: string | null; price?: number | null } | null | undefined
): string | null {
  const description = ticket?.description?.trim();
  if (!description) return null;

  const price = Number(ticket?.price ?? 0);
  const mentionsFree = /gratuit[ao]|grátis|gratis/i.test(description);
  if (price > 0 && mentionsFree) {
    return null;
  }

  return description;
}
